import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Card, Col, Form, Row, Button, TabContent, TabPane } from "reactstrap";
import { IoIosArrowBack } from "react-icons/io";
import Search from "./tab/search";
import Register from "./tab/register";
import Breadcrumb from "../../components/breadcrumbs";
import * as controller from "../../controllers/feriadosController";
import * as actions from "../../store/modules/feriados/actions";
export default function Feriados() {
  const { activeTab, item, registros, seeRegister, permitions } = useSelector(
    (state) => state.feriado
  );

  useEffect(() => {
    actions.setActiveTab("Search");
  }, []);
  function saveItem() {
    if (item.id === "" || item.id === null || item.id === undefined) {
      controller.createFeriado(item);
    } else {
      controller.updateFeriado(item, registros);
    }
  }

  function changeTab(tab) {
    actions.setActiveTab(tab);
    actions.cleanRegister();
  }

  function seeRegisterF() {
    actions.cleanRegister();
    actions.setSeeRegister(false);
  }

  return (
    <>
      <Col>
        <Breadcrumb activeTab={activeTab} />
        <Card>
          <Form>
            {activeTab === "Search" ? (
              permitions.criar && (
                <Col md={12}>
                  <Row className="pt-2 pb-2">
                    <Col md={8}>
                      <Button
                        onClick={() => changeTab("Register")}
                        style={{ width: "210px" }}
                        className="purpleButton"
                      >
                        Cadastrar Feriado
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )
            ) : (
              <Col className="pt-2 pb-2">
                <Button
                  onClick={() => {
                    actions.cleanSearch();
                    seeRegisterF();
                    changeTab("Search");
                  }}
                  style={{ width: "150px", color: "white" }}
                  className="purpleButton"
                >
                  <IoIosArrowBack style={{ marginTop: "3px", float: "left" }} />{" "}
                  Voltar
                </Button>
                {!seeRegister && (
                  <Button
                    onClick={() => saveItem()}
                    style={{ width: "242px", float: "right" }}
                    className="purpleButton"
                  >
                    Salvar Cadastro
                  </Button>
                )}
              </Col>
            )}
          </Form>
        </Card>
      </Col>

      <TabContent style={{ width: "100%" }} activeTab={activeTab}>
        <TabPane tabId="Search">
          <br />
          <Search />
        </TabPane>
        <TabPane tabId="Register">
          <br />
          <Register />
        </TabPane>
      </TabContent>
    </>
  );
}
